<template>
	<ProcessCreatePage>
		<Header :title="title">
			<p>
				{{ $store.getters.isProcessOrderDocumentation ? $t('repair_order_text') : $t('pick_option_input') }}
			</p>
		</Header>

		<div class="main">
			<default-or-value-form
				ref="form"
				v-model="repairOrder"
				:default-value="defaultValue"
				:placeholder="$t('oder_text').toString()"
				@changeRadio="warn"
				:force-custom-value="evaluateCustom()"
			>
				<template #default>
					<label>{{ $t('prepared_oder_text') }}<br /></label>
					<span class="font-semibold">{{ defaultValue }}</span>
				</template>
				<template #custom>
					<p>{{ $t('individual_oder_text') }}<br /></p>
				</template>
			</default-or-value-form>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick"
			:is-back-button="showBackButton"
			:is-skippable="false"
		/>
	</ProcessCreatePage>
</template>

<script>
import Header from '../Header';
import Footer from '../Footer';
import DefaultOrValueForm from '@/components/damagecases/forms/DefaultOrValueForm';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'RepairOrder',
	data() {
		return {
			repairOrder: '',
		};
	},
	props: {
		defaultValue: {
			type: String,
			required: true,
		},
		showBackButton: {
			default: false,
		},
		title: {
			default: function() {
				return this.$t('generate_form_repair_order');
			},
		},
	},
	methods: {
		continueButtonClick() {
			if (!this.$store.getters.isProcessOrderDocumentation) {
				if (this.$refs.form.validate()) {
					if (this.repairOrder === '') {
						this.repairOrder = this.defaultValue;
					}
					this.$emit('next', this.$data);
				} else {
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				}
			} else {
				this.$emit('next', this.$data);
			}
		},
		evaluateCustom() {
			let isCustom = false;
			const damageCase = this.$store.getters.getDamageCase;
			if (this.$store.getters.isProcessComprehensive) {
				if (!damageCase.hasCostEstimation && !damageCase.hasAppraisal) {
					isCustom = true;
				}
			} else if (this.$store.getters.isProcessOrderDocumentation) {
				isCustom = true;
			}
			return isCustom;
		},
		warn($event) {
			if ($event === 'custom' && !this.evaluateCustom()) {
				this.$swal({
					title: this.$t('sure').toString(),
					text: this.$t('individual_text_hint').toString(),
					icon: 'warning',
					cancelButtonText: this.$t('general.cancel').toString(),
					showCancelButton: true,
				}).then(result => {
					if (!result.value) {
						this.$refs.form.setRadioToDefault();
					}
				});
			}
		},
	},
	components: { ProcessCreatePage, DefaultOrValueForm, Footer, Header },
};
</script>

<style scoped></style>
